import {
  DriverResource,
  PolicyResource,
  VehicleResource,
} from '../policies/policyClient.types';

export const TABLE_NAME = 'labeled_data';

export enum LabelingStatus {
  Pending = 'pending',
  InProgress = 'in-progress',
  Complete = 'complete',
}
export interface LabeledDataPolicyResponse extends LabeledDataPolicyResource {
  drivers: DriverResource[];
  vehicles: VehicleResource[];
  update: boolean;
}

export interface LabeledDataPolicyResource
  extends Omit<PolicyResource, 'blocks'> {
  labelingStatus: LabelingStatus;
  notes?: string;
  parsedDecPage?: string;
  parsedDecPageV2?: string;
  jobId?: string;
}

export interface UpdatePolicyPayload {
  policyId?: string;
  premium?: number;
  policyStartDate?: string;
  policyEndDate?: string;
  labelingStatus?: LabelingStatus;
  notes?: string;
}

export interface CreatePolicyJobPayload {
  policyId: string;
  policyUUID: string;
  policyType: string;
  carrierName: string;
}
